import { type FC } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner } from '../../../../../../../components/Spinner/Spinner'
import { NoMeetingResult } from '../../DefaultDisplay/View/NoMeetingResult'
import { type ResultDisplayProps } from '../../common'
import { FutureMeetingRow } from './FutureMeetingRow'
import { FutureMeetings } from './FutureMeetings'
import { getFutureMeetingRows } from './futureMeetingRows'
import { useFutureMeetingBookings } from './useFutureMeetingBookings'
import { hasPresetFutureMeetings } from './utils'

interface SessionFutureMeetingsProps extends ResultDisplayProps {
  sessionId: string
  roomId: string
}

const SessionFutureMeetings: FC<SessionFutureMeetingsProps> = ({ sessionId, roomId, ...resultDisplayProps }) => {
  const { bookings, eventTypeNameById, isLoading } = useFutureMeetingBookings(sessionId, roomId)

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center py-5'>
        <Spinner />
      </div>
    )
  }

  const rows = getFutureMeetingRows(bookings, new Date())

  if (rows.length === 0) {
    return hasPresetFutureMeetings(resultDisplayProps.aiResult) ? <FutureMeetings {...resultDisplayProps} /> : <NoMeetingResult />
  }

  return (
    <div className='d-flex flex-column gap-2'>
      {rows.map(({ booking, expired, pastMeeting }) => (
        <FutureMeetingRow
          key={booking.bookingId}
          booking={booking}
          expired={expired}
          pastMeeting={pastMeeting}
          eventTypeName={booking.eventTypeId ? eventTypeNameById[booking.eventTypeId] : undefined}
        />
      ))}
    </div>
  )
}

export const SchedulingFutureMeetings: FC<ResultDisplayProps> = (props) => {
  const { sessionId, roomId } = useParams()

  if (!sessionId || !roomId) {
    return hasPresetFutureMeetings(props.aiResult) ? <FutureMeetings {...props} /> : <NoMeetingResult />
  }

  return <SessionFutureMeetings {...props} sessionId={sessionId} roomId={roomId} />
}
